import { Component, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-water-modal',
  imports: [MatCardModule, MatDialogModule],
  templateUrl: './water-modal.html',
})
export class WaterModal {
  dialog = inject(MatDialog);

  closeDialog(): void {
    this.dialog.closeAll();
  }
}
